import { companyBasePath } from "@oysterhr/router"
import { PaymentEngagementType } from "../../pages/CompanyPaymentMethodsPage/enums"
import { generatePath } from "react-router-dom"
import { idToStrongId } from "@oysterhr/common"

// PAYMENT INFORMATION
const _paymentMethodsPath = (companyId: string, path?: string) => {
  return companyBasePath({
    companyId,
    path: generatePath("payment-methods/*", { "*": path || "" }),
  })
}

export const companyPaymentMethodsPath = (companyId: string) => {
  return _paymentMethodsPath(companyId)
}

export const companyPaymentMethodAuthorizePath = (companyId: string, paymentMethodId: string) => {
  return _paymentMethodsPath(companyId, `${idToStrongId(paymentMethodId)}/authorize`)
}

// -------- BACS --------
export const companyBacsLandingPagePath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "bacs-landing-page")
}

// -------- PAD --------
export const companyPadLandingPagePath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "pad-landing-page")
}

// -------- SEPA --------
export const companySepaLandingPagePath = (
  companyId: string,
  onlyFor?: PaymentEngagementType.Contractor | PaymentEngagementType.Fte,
) => {
  const path = onlyFor ? `sepa-landing-page/${onlyFor}` : "sepa-landing-page"
  return _paymentMethodsPath(companyId, path)
}

export const companySepaFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "sepa-bank-details")
}

export const companyNewSepaFlowPath = (
  companyId: string,
  type: PaymentEngagementType.Contractor | PaymentEngagementType.Fte,
) => {
  return _paymentMethodsPath(companyId, `sepa/${type}`)
}

export const companySepaMandatePath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "sepa/mandate")
}

// -------- ACH --------
export const companyAchLandingPagePath = (
  companyId: string,
  onlyFor?: PaymentEngagementType.Contractor | PaymentEngagementType.Fte,
) => {
  const path = onlyFor ? `ach-landing-page/${onlyFor}` : "ach-landing-page"
  return _paymentMethodsPath(companyId, path)
}

export const companyAchFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "ach-bank-details")
}

export const companyNewAchFlowPath = (
  companyId: string,
  type: PaymentEngagementType.Contractor | PaymentEngagementType.Fte,
) => {
  return _paymentMethodsPath(companyId, `ach/${type}`)
}
